/**
 * Phase ID — brand watermark for share cards, deity GIFs, story banners.
 */

export function VedaPathWatermark({ className = "" }) {
  return (
    <div
      className={`pointer-events-none select-none text-[10px] sm:text-xs opacity-70 ${className}`}
      data-testid="vedapath-watermark"
      aria-hidden
    >
      © 2026 VedaPath OS
    </div>
  );
}
